module.exports = __webpack_public_path__ + "48dc76f12b760a64ea3884af073913e3.png";